module.exports = __webpack_public_path__ + "assets/fundky_admin_avatar.png";